import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import type {IAsset} from '../schema';

export const canOrganizeAsset = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (isBrandPortal()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.ORGANIZE,
	});
};

export default canOrganizeAsset;
